// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter--2ucu_{box-sizing:border-box;position:relative}.filter--2ucu_ input{background:#fff;border:none;border-radius:2px;box-sizing:border-box;color:#333;font-size:14px;height:48px;padding:0 48px 0 16px;width:100%}.filter--2ucu_ input:focus{outline:none}.filter--2ucu_ input::placeholder{color:#d9d9d9}.filter--2ucu_ svg{margin-top:-5px;position:absolute;right:30px;top:50%}\n", ""]);
// Exports
exports.locals = {
	"filter": "filter--2ucu_"
};
module.exports = exports;
